import Layout from '@/components/Layout';
import Link from 'next/link';

import affirmations from '@/components/affirmations';

import {
  TitleContainer,
  QuoteRow,
  QuoteColumn,
  affirmation,
  Quote,
} from '@/components/Learning';

function TeachingPage() {
  const introText = `Neville Goddard was a New Thought teacher who believed that
  affirmations are a powerful tool for manifesting one's desires. He
  believed that by consistently affirming a desired outcome, a person
  could change their thought patterns and ultimately change their
  reality. He taught that the key to making affirmations effective is
  to feel the emotions of already having achieved the desired outcome,
  as if it has already happened. This creates a powerful emotional
  state that can help attract the desired outcome into reality.`;
  function getAffirmations() {
    return affirmations.map((item) => affirmation(item[0], item[1]));
  }
  return (
    <Layout
      title={'James Newman - CREATING AFFIRMATIONS'}
      description={'learn how to create affirmations in an effective way'}
    >
      <TitleContainer>
        <h2>James Newman</h2>
        <h1>CREATING AFFIRMATIONS</h1>
      </TitleContainer>
      <QuoteRow>
        <QuoteColumn>{introText}</QuoteColumn>
      </QuoteRow>
      <QuoteRow>
        <QuoteColumn className="center">
          <Link
            className="pointer underline"
            href="/neville-goddard/five-lessons#34"
          >
            <strong>Neville on affirmations</strong>
          </Link>
        </QuoteColumn>
      </QuoteRow>
      <QuoteRow>
        <QuoteColumn>
          {getAffirmations()}
          <Quote>
            <h2>EXAMPLES</h2>
            <p>
              <strong>Concentration:</strong>It is easy (positive) for me
              (personal, categorical) to focus (action) my attention and become
              fascinated (excitement) with a project or activity. (present,
              achievement, accuracy, realistic, yourself)
            </p>
            <p>
              <strong>Public Speaking:</strong> I have an enthusiastic,
              conversational style of public speaking and I enjoy the excitement
              of sharing ideas with large groups of people.
            </p>
          </Quote>
        </QuoteColumn>
      </QuoteRow>
      <QuoteRow>
        <QuoteColumn className={`center`}>
          Read the following
          {` `}
          <Link
            className={`underline`}
            href={`/joseph-murphy/mental-healing-techniques`}
          >
            <strong>guide</strong>
          </Link>
          {` `}on how to use affirmations
        </QuoteColumn>
      </QuoteRow>
    </Layout>
  );
}

export default TeachingPage;
